import Chart from "react-apexcharts";

export default function LineTotalPorDia({ data }) {
  const dias = Object.keys(data?.totalPorDia || {}); // datas
  const valores = Object.values(data?.totalPorDia || {}); // valores

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
    },
    stroke: {
      curve: "smooth", // curva suave
      width: 3,
    },
    xaxis: {
      categories: dias,
      labels: {
        rotate: -45,
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        formatter: (value) =>
          Number(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
      },
    },
    tooltip: {
      y: {
        formatter: (value) =>
          Number(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
      },
    },
    colors: ["rgba(59, 130, 246, 1)"], // cor da linha
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    legend: {
      show: true,
      position: "top",
      labels: { colors: "#333" },
      markers: { width: 12, height: 12 },
    },
  };

  const series = [
    {
      name: "Total (R$)",
      data: valores,
    },
  ];

  return (
    <div className="bg-card border border-border p-4 rounded-2xl shadow-soft">
      <h2 className="text-xl font-display font-bold mb-4 text-foreground">Total Geral/Dia</h2>
      <Chart options={options} series={series} type="line" height={350} />
    </div>
  );
}
